import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { IKPIConfigData, KPIConfigService } from 'app/modules/settings/services/kpi-config.service';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { orderBy, SortDescriptor } from '@progress/kendo-data-query';
import { ToastService } from 'app/modules/shared/services/toast.service';
import { timeout } from 'rxjs/operators';

@Component({
    selector: 'app-kpi-config',
    templateUrl: './kpi-config.component.html',
    styleUrls: ['./kpi-config.component.scss'],
})
export class KpiConfigComponent implements OnInit {
    tabs = [
        { label: 'Select KPIs', index: 0 },
        //{ label: 'Set Targets', index: 1 },
        { label: 'Define Ranges', index: 1 },
        { label: 'Review and Submit', index: 2 },
    ];
    originalData: IKPIConfigData[];
    data: IKPIConfigData[];
    loading: boolean = true;
    hasInvalidData: boolean = false;
    dataSaved: boolean = false;
    public tab: number = 0;
    public progress: number = 0;
    isSaving = false;
    searchTerm: string;
    constructor(private kpiConfigService: KPIConfigService, private toast: ToastService) {}

    ngOnInit() {
        this.searchTerm = '';
        this.getData();
    }

    // Fetch KPI data for display on all tabs. This list will be used and maintained on each tab.
    private getData() {
        this.loading = true;
        this.kpiConfigService.getKPIConfig().subscribe(
            (results) => {
                if (results && results.length !== 0) {
                    this.originalData = JSON.parse(JSON.stringify(results));
                    this.data = results;
                } else {
                    this.data = null;
                }

                this.loading = false;
            },
            (error) => {
                this.loading = false;
            }
        );
    }

    public handleTabChange(event) {
        this.tab = event;
        this.progress = this.tab * 33;
    }

    public next() {
        if (this.tab !== 2) {
            if (!this.hasInvalidData) {
                this.handleTabChange(this.tab + 1);
            }
        }
    }

    public nextDisabled() {
        return this.tab == 2;
    }

    public back() {
        this.hasInvalidData = false;
        if (this.tab > 0) {
            this.handleTabChange(this.tab - 1);
        }
    }

    public backDisabled() {
        return this.tab == 0;
    }

    // Check for valid state on current or all pages
    canSave() {
        return true;
    }

    save() {
        if (!this.isSaving) {
            const isAllDataValid = this.kpiConfigService.isAllDataValid(this.data);
            if (isAllDataValid) {
                this.hasInvalidData = false;
                this.toast.info(
                    'KPI changes are being saved. This could take up to a minute or more'
                );
                this.isSaving = true;
                let changedData = this.checkForChangedData(this.data);
                let formData = this.formatDataForSave(changedData);
                this.kpiConfigService.saveKPIConfig(formData).subscribe(
                    (_) => {
                        this.dataSaved = true;
                        this.toast.success('KPI changes have been saved successfully');
                        this.isSaving = false;

                        setTimeout(() => {
                            this.dataSaved = false;
                        }, 10000);
                    },
                    (error) => {
                        this.isSaving = false;
                        throw new Error(error);
                    }
                );
            } else {
                this.hasInvalidData = true;
            }
        }
    }

    formatDataForSave(data): IKPIConfigData[] {
        let result = [];
        data.forEach((x) => {
            result.push({
                ClientKPIKey: x.clientKPIKey,
                KPIMasterKey: x.kpiMasterKey,
                KPIMilestoneStaffingKey: x.kpiMilestoneStaffingKey,
                KPIMilestoneKey: x.kpiMilestoneKey,
                KPIMilestoneBPSKey: x.kpiMilestoneBPSKey,
                KPIMilestoneCustomKey: x.kpiMilestoneCustomKey,
                ClientKPIDescription: x.clientKPIDescription,
                Target: x.target,
                ActiveDate: x.activeDate,
                InActiveDate: x.inActiveDate,
                IsActive: x.isActive,
                isDeleted: x.isDeleted,
                IsWeightedByLA: x.isWeightedByLA,
                Range1End: x.range1End,
                Range2Start: x.range2Start,
                Range2End: x.range2End,
                Range3Start: x.range3Start,
                Range3End: x.range3End,
                Range4Start: x.range4Start,
                Range4End: x.range4End,
                Range5Start: x.range5Start,
            });
        });

        return result;
    }

    updateKPIfData(event: IKPIConfigData[]) {
        this.data = event;
    }

    checkForChangedData(updatedData) {
        const changedData = [];
        const excludedProperties = [
            'errors',
            'targetError',
            'range3EndError',
            'range3StartError',
            'range2StartError',
            'range4EndError',
        ];
        for (let i = 0; i < updatedData.length; i++) {
            if (!this.isSameValue(updatedData[i], this.originalData[i], excludedProperties)) {
                changedData.push(updatedData[i]);
            }
        }
        return changedData;
    }

    isSameValue(obj1, obj2, excludedProperty) {
        const keys1 = Object.keys(obj1).filter((key) => !excludedProperty.includes(key));
        const keys2 = Object.keys(obj2).filter((key) => !excludedProperty.includes(key));
        if (keys1.length !== keys2.length) {
            return false;
        }

        for (let key of keys1) {
            if (obj1[key] !== obj2[key]) {
                return false;
            }
        }

        return true;
    }

    searchRows(event) {
        this.searchTerm = event;
    }

    exportToExcel() {}
}
